import React from "react";
import {useTheme} from "../../../contexts/theme";
import {RadioGroup} from "@mui/material";

interface StyledRadioGroupProps  {
    row: boolean;
    children?: React.ReactNode;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
}

const StyledRadioGroup: React.FC<StyledRadioGroupProps> = ({row,children,onChange, value}) => {
    const theme = useTheme();

    return (
        <RadioGroup
            row={row}
            onChange={onChange}
            value={value}
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            sx={{
                color: theme.palette.white,
                '& .MuiRadio-root': {
                    color: theme.palette.white, // Colore non selezionato
                    '&.Mui-checked': {
                        color: theme.palette.orange, // Colore selezionato
                    },
                },
            }}
        >
            {children}
        </RadioGroup>
    );
}

export default StyledRadioGroup;